import { StoryThreadLayout } from "./utils/helpers";
import { StoryThreadPayload } from "./utils/types";

type StoryThreadContentProps = Pick<StoryThreadPayload, "data">;

export default function StoryThreadPage({
  data,
}: StoryThreadContentProps): React.ReactElement {
  const Layout = StoryThreadLayout(data.entity.tag.urlPath);

  return <Layout data={data} />;
}
